import AuthService from './auth.service.js';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return AuthService.login(user)
          .then(user => {
            commit('loginSuccess', user);
            return Promise.resolve(user);
          })
          .catch(error => {
            commit('loginFailure');
            return Promise.reject(error);
          });
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
          response => {
            commit('registerSuccess');
            return Promise.resolve(response.data);
          },
          error => {
            commit('registerFailure');
            return Promise.reject(error);
          }
      );
    }
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
      localStorage.setItem('user', JSON.stringify(user)); // Сохраняем пользователя
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
      localStorage.removeItem('user'); // Удаляем пользователя
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
      localStorage.removeItem('user'); // Удаляем пользователя
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    }
  },
  getters: {
    isAdmin: state => {
      return (
          state.user &&
          state.user.roles &&
          state.user.roles.includes('ROLE_ADMIN')
      );
    },
    isModerator: state => {
      return (
          state.user &&
          state.user.roles &&
          state.user.roles.includes('ROLE_MODERATOR')
      );
    },
    hasRole: state => role => {
      return (
          state.user &&
          state.user.roles &&
          state.user.roles.includes(role)
      );
    }
  }
};
